import { inject, Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable, of } from 'rxjs';

import { CsvAsStringArrays } from '@malou-io/package-utils';

import { ReviewsEvolutionWithRange } from '#modules/reviews/models/reviews.interface';
import { AbstractCsvService } from '#modules/statistics/components/download-insights-modal/models/csv-service.abstract';
import { StatisticsStore } from '#modules/statistics/stores/store/statistics.store';

type Data = ReviewsEvolutionWithRange | undefined;

@Injectable()
export class ReviewsRatingsEvolutionCsvInsightsService extends AbstractCsvService<Data> {
    private readonly _statisticsStore = inject(StatisticsStore);

    protected override _isDataValid(data: Data): boolean {
        return !!data;
    }

    protected override _getData$(): Observable<Data> {
        return of(this._statisticsStore.reviewsRatingsEvolutionData());
    }

    protected override _getCsvDataRows(data: Exclude<Data, undefined>): CsvAsStringArrays {
        return data.results.dataPerDay.map((d) => {
            const date = DateTime.fromObject({ ordinal: d.day, year: d.year }).toJSDate();
            const dateString = date.toISOString();
            const value = d.total.toString();
            return [dateString, value];
        });
    }

    protected override _getCsvHeaderRow(): CsvAsStringArrays[0] {
        return ['Date', 'Review Count'];
    }
}
